// Resource Hub
jQuery(".resources-section__group-category-name").on("click", function () {
  $(".resources-section__group-category-file").show();
  $(".resources-section__search-input").val("");
  $(".resources-section__search .not-found").removeClass("active");
  $(this)
    .parents(".resources-section__groups")
    .find(".active")
    .removeClass("active");
  $(this).parents(".resources-section__group-category").toggleClass("active");
});

jQuery(".resources-section__search-input").on("keyup blur", function () {
  var search = $(this).val();
  $(".resources-section__search .not-found").removeClass("active");
  $(".resources-section__group-category-file").show();
  $(".resources-section__groups").find(".active").removeClass("active");
  var results = $(".resources-section__group-category-file");
  if (search.length >= 2) {
    console.log("searching for " + search);
    // $(".resources-section__group-category").addClass("active");
    $(".resources-section__group-category-file").hide();
    // $('.resources-section__group-category-file:contains('+search+')').parents(".resources-section__group-category-file").show().parents(".resources-section__group-category").addClass("active");
    results
      .filter(function () {
        return (
          $(this)
            .text()
            .toLowerCase()
            .indexOf(
              $(".resources-section__search-input").val().toLowerCase()
            ) >= 0
        );
      })
      .show()
      .parents(".resources-section__group-category")
      .addClass("active");
    // console.log("results: "+results.length);

    if (results.length < 1) {
      $(".resources-section__search .not-found").addClass("active");
    }
  }
  // Highlight search term in title string...
  results.find(".resource-title-text").each(function () {
    $(this).html(function (i, txt) {
      var s = $(".resources-section__search-input").val();
      txt = txt.replace("<b>", "").replace("</b>", "");
      if (s.length >= 2) {
        var re = new RegExp(s, "gi");
        return txt.replace(re, "<b>" + s + "</b>");
      } else {
        return txt;
      }
    });
  });
});
